var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "width": 300
    }
  }, [_c('DxTabPanel', {
    attrs: {
      "id": "tabPanel",
      "defer-rendering": false
    }
  }, [_c('DxItem', {
    attrs: {
      "title": "Test"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('div', [_vm._v("hello")])];
      },
      proxy: true
    }])
  }), _c('DxItem', {
    attrs: {
      "title": "Test2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('div', [_vm._v("hello2")])];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }